import type { SupportConfig } from '../../types/api/v2/obt/model/support-config';

export const verifyGenesysChatIsEnabled = (supportConfig: SupportConfig | undefined) =>
  supportConfig?.genesysConfig?.enabled === true && supportConfig?.genesysConfig.dataUrl !== undefined;
